import React from 'react';
import styles from './ViewToggle.module.css';

const ViewToggle = ({ viewMode, onViewModeChange }) => {
    return (
        <div className={styles.container}>
            <button
                className={`${styles.button} ${viewMode === 'table' ? styles.active : ''}`}
                onClick={() => onViewModeChange('table')}
                title="Visualização em Lista"
            >
                <i className={`fas fa-list ${styles.icon}`}></i>
                <span>Lista</span>
            </button>
            <button
                className={`${styles.button} ${viewMode === 'grid' ? styles.active : ''}`}
                onClick={() => onViewModeChange('grid')}
                title="Visualização em Grade"
            >
                <i className={`fas fa-th-large ${styles.icon}`}></i>
                <span>Grade</span>
            </button>
        </div>
    );
};

export default ViewToggle;
